export function isCarryInOutDay(calendarDayIdx, bidSessionDays, prevBuffer = 1) {
  if (calendarDayIdx < prevBuffer || calendarDayIdx >= (bidSessionDays + prevBuffer)) {
    return true;
  }
  return false;
}
